<template>
  <div class="k-icon-picker">
    <v-menu offset-y :close-on-content-click="false" width="310" height="500">
      <template v-slot:activator="{ props }">
        <!-- Button with dynamic icon -->
        <v-btn v-bind="props" elevation="0" class="k-dropdown-btn">
          <i :class="`${theme} ${modelValue || defaultIcon}`"></i> <!-- Gebruik default als modelValue leeg is -->
          <i class="icon-dropdown fal fa-chevron-down"></i>
        </v-btn>
      </template>

      <v-card class="k-icon-picker-group">
        <v-text-field v-model="filter_icons" density="compact" class="bg-filled-input" variant="solo" size="small"
          placeholder="Search icons"></v-text-field>

        <v-item-group selected-class="bg-primary" class="widgets-group-flex">
          <v-btn v-for="item in essentialsIcons" :key="item.icon" class="btn" icon @click="updateIcon(item.icon)">
            <i :class="`${theme} ${item.icon}`"></i>
          </v-btn>
        </v-item-group>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import { icons } from "@/util/Icons";

export default {
  name: "KIconPicker",
  props: {
    modelValue: {
      type: String,
      default: "fa-comment", // default icon
    },
    theme: {
      type: String,
      default: "fal",
    },
    defaultIcon: {
      type: String,
      default: "fa-comment", // Standaardicoon als modelValue niet is ingesteld
    },
  },
  data() {
    return {
      filter_icons: "",
      icons_list: icon.fontawesome(),
    };
  },
  computed: {
    essentialsIcons() {
      return this.icons_list.filter((item) =>
        item.title.toLowerCase().includes(this.filter_icons.toLowerCase())
      );
    },
  },
  methods: {
    updateIcon(newIcon) {
      // Emit 'update:modelValue' for v-model binding
      this.$emit("update:modelValue", newIcon);
    },
  },
};
</script>

<style scoped>
.k-icon-picker-group {
  padding: 10px;
  border-radius: 10px !important;
}


.k-dropdown-btn {
  background: #ececed !important;
  border-radius: 8px !important;
  border: 1px solid var(--neutral-200, #dfdfdf) !important;
  padding: 0px !important;

  .v-btn__content {
    display: flex;
    justify-content: space-between !important;
    gap: 10px;

  }

  .icon-dropdown {
    font-size: 12px;
  }
}
</style>
